import UserResource  from "./ApiResources/UserResource";
import UsersResource from "../Admin/ApiResources/UsersResource";

export default class User {

    constructor(id = '', name = '', email = '', avatar = null) {
        this.id = id;
        this.name = name;
        this.email = email;
        this.avatar = avatar
    }

    static async find(id) {
        return this.resource.show(id).then(({ data }) => {
            return data;
        });
    }

    static get resource() {
        return new UsersResource();
    }

    static update(data) {
        return new UserResource().update(data);
    }

    static async getAllUsers() {
        return await this.resource.index().then(({ data }) => {
            return data;
        });
    }

}
